import { render, staticRenderFns } from "./reminder-icon.vue?vue&type=template&id=3b90feb8"
import script from "./reminder-icon.vue?vue&type=script&lang=js"
export * from "./reminder-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b90feb8')) {
      api.createRecord('3b90feb8', component.options)
    } else {
      api.reload('3b90feb8', component.options)
    }
    module.hot.accept("./reminder-icon.vue?vue&type=template&id=3b90feb8", function () {
      api.rerender('3b90feb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/reminder-icon.vue"
export default component.exports